export default __webpack_public_path__ + "static/media/OPENPORTS_Dashboard.032bceae.svg";